import React, { useRef } from "react"
import { Controller } from "react-hook-form"
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6"
import { FaSquareMinus, FaSquarePlus } from "react-icons/fa6"
import { FiEdit } from "react-icons/fi"
import { IoCheckmark, IoInformationOutline, IoSearch } from "react-icons/io5"
import {
  LuChevronDown,
  LuChevronLeft,
  LuChevronUp,
  LuCircleCheck,
  LuMoveLeft,
} from "react-icons/lu"
import { useNavigate } from "react-router-dom"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import GenericFeedback from "@fuse/sharedComponents/GenericFeedback"
import BlurredLoadingSpinner from "@fuse/sharedComponents/loader/BlurredLoadingSpinner"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { countryData } from "@letshang/assets"
import CountriesFlag from "@letshang/assets/countries_flags.json"
import { getPhoneNumberPlaceholder } from "@letshang/utils"
import { filter, get, isEmpty, map, size } from "lodash-es"
import { useRecoilValue } from "recoil"

import { userStateForAnalytics } from "@fuse/recoil/signup"

import BuyTicketsLayout from "@fuse/pages/eventSignUp/BuyTickets/components/BuyTicketsLayout"
import InfoModal, {
  InfoModalHandle,
} from "@fuse/pages/eventSignUp/BuyTickets/components/InfoModal"
import { useTicketFormController } from "@fuse/pages/eventSignUp/BuyTickets/FillFriendsTicketInfo/useFriendsTicketInfo"

const FillFriendsTicketInfo = () => {
  const navigate = useNavigate()
  const modalRef = useRef<InfoModalHandle>(null)

  const {
    eventId,
    isLoading,
    flyerImage,
    control,
    handleSubmit,
    errors,
    form,
    fields,
    setValue,
    onSearchBuddies,
    onSelectBuddyAsAGuest,
    onSelectCurrentUserTicket,
    toggleCountryPicker,
    getFormattedPhone,
    onAddManualDetails,
    onToggleItem,
    canResetIsManualData,
    isHaveMyTicket,
    onSubmit,
    setAddOnsDetails,
    addOnsDetails,
    onFillQuestioners,
    isQuestionnairesNeeded,
    onAddInfoManually,
    userId,
    ticketsWithTotalPrice,
  } = useTicketFormController()

  const isSingleTicket = size(get(form, "tickets")) === 1

  const handleBackPress = () => {
    navigate(-1)
  }

  const HeaderComponent = () => (
    <div className="p-2 md:p-10">
      <div className="left-4 md:top-12 md:left-12 flex items-center space-x-2 z-20">
        <div
          onClick={handleBackPress}
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex justify-center items-center bg-white/10 cursor-pointer "
        >
          <LuChevronLeft className="text-white text-2xl mr-0.5 md:hidden" />
          <LuMoveLeft className="text-white text-md md:text-2xl hidden md:flex" />
        </div>
      </div>
    </div>
  )

  const searchNumberView = (index: number) => {
    const searchTerm = get(form, `tickets.${index}.searchTerm`, "")
    const isMyTicket = get(form, `tickets.${index}.isMyTicket`, false)

    return (
      <>
        <div className="flex flex-row bg-white/15 px-3 rounded-lg items-center justify-center overflow-hidden mt-4">
          <IoSearch className="text-white text-xl mr-2" />

          <Controller
            name={`tickets.${index}.searchTerm`}
            control={control}
            render={({ field: { value, onChange, onBlur } }) => (
              <>
                <input
                  type="text"
                  placeholder="Search by name or phone number"
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value)
                    onSearchBuddies(e.target.value, index)
                  }}
                  onBlur={onBlur}
                  className="w-full h-10 bg-transparent text-white placeholder-white35 focus:outline-none text-sm"
                />
              </>
            )}
          />
        </div>

        {!isEmpty(searchTerm) && (
          <Controller
            name={`tickets.${index}.searchBuddyResult`}
            control={control}
            render={({ field: { value, onChange, onBlur } }) => {
              if (!isEmpty(value)) {
                return (
                  <div className="flex flex-col gap-3 py-3 bg-white/15 px-3 rounded-lg mt-2 max-h-36 overflow-auto">
                    {value?.map((item) => {
                      return (
                        <div
                          key={get(item, "buddyId")}
                          className="flex flex-row gap-2 cursor-pointer"
                          onClick={() => {
                            onSelectBuddyAsAGuest(item, index)
                          }}
                          onBlur={onBlur}
                        >
                          <div className="h-6 w-6 rounded-full bg-gray-600 overflow-hidden">
                            <img
                              src={get(item, "avatarUrl", "")}
                              alt={get(item, "name", "") || "Unknown"}
                            />
                          </div>
                          <p className="text-sm text-start text-white">
                            {get(item, "name", "")}
                          </p>
                        </div>
                      )
                    })}
                  </div>
                )
              } else {
                return (
                  <div>
                    <div className="flex flex-row gap-4 mt-4">
                      <div className="h-8 w-8 p-4 rounded-full bg-blue-950 flex items-center justify-center relative">
                        <div className="h-5 w-5 rounded-full bg-blue-600 flex items-center justify-center absolute">
                          <IoInformationOutline className="text-blue-950" />
                        </div>
                      </div>

                      <div className="flex">
                        <p className="text-sm text-start text-white">
                          It seems you're not connected with this person or they
                          might not be on the app
                        </p>
                      </div>
                    </div>

                    {/* {!isSingleTicket && ( */}
                    <Controller
                      name={`tickets.${index}.isManual`}
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <button
                          className="mt-4 flex w-full flex-row items-center justify-center gap-4 bg-white/10"
                          onClick={() => {
                            onChange(!value)
                            onAddInfoManually(index)
                          }}
                        >
                          <p className="text-white">Add info manually</p>
                        </button>
                      )}
                    />
                    {/* )} */}
                  </div>
                )
              }
            }}
          />
        )}

        {(!isHaveMyTicket || isMyTicket) && !isSingleTicket && (
          <Controller
            name={`tickets.${index}.isMyTicket`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <div
                className="flex mt-4 items-center cursor-pointer"
                onClick={() => {
                  // onChange(!value)
                  onSelectCurrentUserTicket(value, index)
                }}
              >
                {!value ? (
                  <FaRegSquare className={`text-white h-[1.5rem]`} />
                ) : (
                  <FaSquareCheck className={`text-white h-[1.5rem]`} />
                )}
                <p className="ms-2 text-sm font-medium text-white cursor-pointer">
                  This is my ticket
                </p>
              </div>
            )}
          />
        )}
      </>
    )
  }

  const renderFriendsInfoFormItem = (item, index) => {
    const isManual = get(form, `tickets.${index}.isManual`, false)
    const searchTerm = get(form, `tickets.${index}.searchTerm`, "")
    const country = get(form, `tickets.${index}.country`, "")
    const isMyTicket = get(form, `tickets.${index}.isMyTicket`, false)
    const countryPhoneCode = get(form, `tickets.${index}.countryPhoneCode`, "")
    const isCountryPicketModal = get(
      form,
      `tickets.${index}.isCountryPicketModal`,
      false,
    )
    const ticketAddOns = get(form, `tickets.${index}.ticketAddOns`, [])
    const isQuestionnairesNeeded = get(
      form,
      `tickets.${index}.isQuestionnairesNeeded`,
      false,
    )
    const displayedPhoneNumber = get(
      form,
      `tickets.${index}.displayedPhoneNumber`,
      "",
    )
    const name = get(form, `tickets.${index}.name`, "")
    const isDisableDone = isEmpty(displayedPhoneNumber) || isEmpty(name)

    return (
      <div className="px-4 pb-4">
        <div className="h-[0.1px] bg-white/10 -mt-2"></div>

        {isManual ? (
          <div className="mt-4 flex flex-col ">
            <p className="text-white text-sm text-start">
              Ticket holder’s phone number
            </p>

            <div className="flex flex-row h-10 gap-2 items-center justify-center my-3">
              <div
                // className="flex items-center justify-center w-5 h-5 cursor-pointer"
                className="flex items-center justify-center w-12 h-10 bg-white/20 rounded-md cursor-pointer"
                onClick={() => {
                  toggleCountryPicker(index)
                }}
              >
                <img
                  alt="Country Flag"
                  className="w-5 h-5 self-center mt-0.5"
                  src={
                    CountriesFlag[
                      country?.toLocaleLowerCase() as keyof typeof CountriesFlag
                    ]
                  }
                />
              </div>

              <Controller
                name={`tickets.${index}.displayedPhoneNumber`}
                control={control}
                render={({ field: { value, onChange, onBlur } }) => {
                  const placeHolder = get(
                    getPhoneNumberPlaceholder(country),
                    "placeHolder",
                    "",
                  )
                  return (
                    <div className="px-4 bg-white/20 h-10 rounded-md flex w-full items-center">
                      <p className="text-white text-sm">{countryPhoneCode}</p>
                      <input
                        placeholder={placeHolder}
                        value={value}
                        maxLength={size(placeHolder)}
                        // onChange={(e) => onChange(e.target.value)}
                        onChange={(e) =>
                          getFormattedPhone(e.target.value, index)
                        }
                        onBlur={onBlur}
                        className="w-full bg-transparent text-white placeholder-white35 focus:outline-none text-sm px-2"
                      />
                    </div>
                  )
                }}
              />
            </div>
            {errors.tickets?.[index]?.phoneNumber && (
              <p className="text-red-500 text-start text-sm mb-2">
                {errors.tickets[index]?.phoneNumber?.message}
              </p>
            )}

            {isCountryPicketModal && (
              <Controller
                name={`tickets.${index}.country`}
                control={control}
                render={({ field: { value, onChange } }) => {
                  return (
                    <div className="flex flex-col gap-3 py-3 bg-white/15 px-3 rounded-md mb-2 max-h-36 overflow-y-scroll">
                      {countryData?.map((item) => {
                        return (
                          <div
                            key={get(item, "code")}
                            className={`flex flex-row gap-2 cursor-pointer items-center`}
                            onClick={() => {
                              onChange(get(item, "code"))
                              setValue(
                                `tickets.${index}.countryPhoneCode`,
                                get(item, "dial_code", ""),
                              )
                              toggleCountryPicker(index)
                            }}
                          >
                            <div className="h-5 w-5 bg-gray-600 overflow-hidden">
                              <img
                                src={
                                  CountriesFlag[
                                    item.code?.toLocaleLowerCase() as keyof typeof CountriesFlag
                                  ]
                                }
                                alt="india"
                              />
                            </div>
                            <p className="text-sm text-start text-white">
                              {get(item, "name", "")}
                            </p>

                            {item.code === country && (
                              <IoCheckmark className="text-white" />
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )
                }}
              />
            )}

            <p className="text-white text-sm text-start">
              Ticket holder’s name
            </p>
            <Controller
              name={`tickets.${index}.name`}
              control={control}
              render={({ field: { value, onChange, onBlur } }) => (
                <div
                  className={`px-4 bg-white/20 h-10 rounded-md flex w-full items-center mt-4`}
                >
                  <input
                    type="text"
                    placeholder="John Doe"
                    value={value}
                    onChange={(e) => {
                      const value = e.target.value
                      onChange(value)
                      canResetIsManualData(value, index)
                    }}
                    onBlur={onBlur}
                    className="w-full h-full bg-transparent text-white placeholder-white35 focus:outline-none text-sm"
                  />
                </div>
              )}
            />
            {errors.tickets?.[index]?.name && (
              <p className="text-red-500 text-start text-sm mt-2">
                {errors.tickets[index].name.message}
              </p>
            )}

            {(!isHaveMyTicket || isMyTicket) && !isSingleTicket && (
              <Controller
                name={`tickets.${index}.isMyTicket`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div
                    className="flex my-4 items-center cursor-pointer"
                    onClick={() => {
                      // onChange(!value)
                      onSelectCurrentUserTicket(value, index)
                    }}
                  >
                    {!value ? (
                      <FaRegSquare className={`text-white h-[1.5rem]`} />
                    ) : (
                      <FaSquareCheck className={`text-white h-[1.5rem]`} />
                    )}
                    <p className="ms-2 text-sm font-medium text-white cursor-pointer">
                      This is my ticket
                    </p>
                  </div>
                )}
              />
            )}

            <Controller
              name={`tickets.${index}.isDetailsAdded`}
              control={control}
              render={({ field: { value } }) => (
                <button
                  className={`flex w-full flex-row items-center justify-center mt-4  ${isDisableDone ? "bg-white/10 opacity-80" : "bg-white/10"}`}
                  // className=" border-t-[0.1px] border-t-white/10"
                  // onClick={() => onChange(!value)}
                  disabled={isDisableDone}
                  onClick={() => {
                    if (!value) {
                      onAddManualDetails(index)
                    } else {
                      onToggleItem(index)
                    }
                  }}
                >
                  <p className="text-white text-sm">Done</p>
                </button>
              )}
            />

            <Controller
              name={`tickets.${index}.isManual`}
              control={control}
              render={({ field: { value, onChange } }) => (
                <button
                  className="flex w-full flex-row items-center justify-center gap-4 bg-transparent mt-2 -mb-2"
                  // className=" border-t-[0.1px] border-t-white/10"
                  onClick={() => onChange(!value)}
                >
                  <p className="text-white text-sm">Go back to search</p>
                </button>
              )}
            />

            {!isEmpty(ticketAddOns) && (
              <Controller
                name={`tickets.${index}.isExtendAddOns`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div className="border-t-[0.1px] border-b-[0.1px] border-white/10 py-4 mt-4">
                    <div
                      // className={` ${!isSingleTicket && "border-t-[0.1px] border-b-[0.1px]"} flex flex-row items-center border-t-white/10 border-b-white/10 mt-4 py-4 cursor-pointer`}
                      className={`flex flex-row items-center border-t-white/10 border-b-white/10 cursor-pointer`}
                      onClick={() => onChange(!value)}
                    >
                      <p className="text-white flex flex-1">Choose an add-on</p>

                      {value ? (
                        <FaSquareMinus className="text-white text-xl" />
                      ) : (
                        <FaSquarePlus className="text-white text-xl" />
                      )}
                    </div>

                    {value && (
                      <Controller
                        name={`tickets.${index}.ticketAddOns`}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="flex flex-col gap-2 mt-4">
                            {value.map((addOns, index) => {
                              const isSelected = get(
                                addOns,
                                "isSelected",
                                false,
                              )

                              const onSelectAddOns = () => {
                                const updateTicketAddOns = map(
                                  value,
                                  function (obj, i) {
                                    return {
                                      ...obj,
                                      isSelected:
                                        i === index
                                          ? !get(obj, "isSelected")
                                          : get(obj, "isSelected"),
                                    }
                                  },
                                )

                                onChange(updateTicketAddOns)
                              }

                              return (
                                <div
                                  key={`addOns-${index}`}
                                  className="flex flex-row pl-4 gap-2 cursor-pointer"
                                  onClick={() => onSelectAddOns()}
                                >
                                  {isSelected ? (
                                    <FaSquareCheck className="text-white text-xl mt-1" />
                                  ) : (
                                    <FaRegSquare className="text-white text-xl mt-1" />
                                  )}

                                  <div className="flex flex-1 flex-col gap-0.5">
                                    <p className="text-start text-sm text-white">
                                      {get(addOns, "ticketName", "")}
                                    </p>
                                    <div className="flex flex-row items-center">
                                      <p
                                        className="text-sm text-gray-400 cursor-pointer"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setAddOnsDetails(addOns)
                                          modalRef.current?.openModal()
                                        }}
                                      >
                                        More info
                                      </p>
                                      <LuChevronDown
                                        className="text-gray-400 text-xl cursor-pointer"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setAddOnsDetails(addOns)
                                          modalRef.current?.openModal()
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <p className="text-white text-sm">
                                    ${get(addOns, "ticketPrice", 0)}
                                  </p>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      />
                    )}
                  </div>
                )}
              />
            )}

            {isQuestionnairesNeeded && (
              <Controller
                name={`tickets.${index}.attendeeQuestionersAnswer`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <button
                    className="mt-4 flex w-full flex-row items-center justify-center gap-4 bg-white/10"
                    onClick={() => {
                      onFillQuestioners(index)
                    }}
                  >
                    <p className="text-white">Fill out questionnaire</p>
                    {!isEmpty(value) && (
                      <LuCircleCheck className="text-white35 text-md md:text-2xl" />
                    )}
                  </button>
                )}
              />
            )}
          </div>
        ) : (
          <>
            {!isSingleTicket && (
              <div className="flex flex-row bg-white/15 px-3 rounded-lg items-center justify-center overflow-hidden mt-4">
                <IoSearch className="text-white text-xl mr-2" />

                <Controller
                  name={`tickets.${index}.searchTerm`}
                  control={control}
                  render={({ field: { value, onChange, onBlur } }) => (
                    <>
                      <input
                        type="text"
                        placeholder="Search by name or phone number"
                        value={value}
                        onChange={(e) => {
                          onChange(e.target.value)
                          onSearchBuddies(e.target.value, index)
                        }}
                        onBlur={onBlur}
                        className="w-full h-10 bg-transparent text-white placeholder-white35 focus:outline-none text-sm"
                      />
                    </>
                  )}
                />
              </div>
            )}

            {!isEmpty(searchTerm) && (
              <Controller
                name={`tickets.${index}.searchBuddyResult`}
                control={control}
                render={({ field: { value, onChange, onBlur } }) => {
                  if (!isEmpty(value)) {
                    return (
                      <div className="flex flex-col gap-3 py-3 bg-white/15 px-3 rounded-lg mt-2 max-h-36 overflow-auto">
                        {value?.map((item) => {
                          return (
                            <div
                              key={get(item, "buddyId")}
                              className="flex flex-row gap-2 cursor-pointer"
                              onClick={() => {
                                onSelectBuddyAsAGuest(item, index)
                              }}
                              onBlur={onBlur}
                            >
                              <div className="h-6 w-6 rounded-full bg-gray-600 overflow-hidden">
                                <img
                                  src={get(item, "avatarUrl", "")}
                                  alt={get(item, "name", "") || "Unknown"}
                                />
                              </div>
                              <p className="text-sm text-start text-white">
                                {get(item, "name", "")}
                              </p>
                            </div>
                          )
                        })}
                      </div>
                    )
                  } else {
                    return (
                      <div>
                        <div className="flex flex-row gap-4 mt-4">
                          <div className="h-8 w-8 p-4 rounded-full bg-blue-950 flex items-center justify-center relative">
                            <div className="h-5 w-5 rounded-full bg-blue-600 flex items-center justify-center absolute">
                              <IoInformationOutline className="text-blue-950" />
                            </div>
                          </div>

                          <div className="flex">
                            <p className="text-sm text-start text-white">
                              It seems you're not connected with this person or
                              they might not be on the app
                            </p>
                          </div>
                        </div>

                        {/* {!isSingleTicket && ( */}
                        <Controller
                          name={`tickets.${index}.isManual`}
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <button
                              className="mt-4 flex w-full flex-row items-center justify-center gap-4 bg-white/10"
                              onClick={() => {
                                onChange(!value)
                                onAddInfoManually(index)
                              }}
                            >
                              <p className="text-white">Add info manually</p>
                            </button>
                          )}
                        />
                        {/* )} */}
                      </div>
                    )
                  }
                }}
              />
            )}

            {(!isHaveMyTicket || isMyTicket) && !isSingleTicket && (
              <Controller
                name={`tickets.${index}.isMyTicket`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div
                    className="flex mt-4 items-center cursor-pointer"
                    onClick={() => {
                      // onChange(!value)
                      onSelectCurrentUserTicket(value, index)
                    }}
                  >
                    {!value ? (
                      <FaRegSquare className={`text-white h-[1.5rem]`} />
                    ) : (
                      <FaSquareCheck className={`text-white h-[1.5rem]`} />
                    )}
                    <p className="ms-2 text-sm font-medium text-white cursor-pointer">
                      This is my ticket
                    </p>
                  </div>
                )}
              />
            )}

            {isSingleTicket && (
              <Controller
                name={`tickets.${index}.isDetailsAdded`}
                control={control}
                render={({ field: { value: isDetailsAdded, onChange } }) => {
                  const avatarUrl = get(form, `tickets.${index}.avatarUrl`, "")
                  const name = get(form, `tickets.${index}.name`, "")
                  return (
                    <div className="flex flex-row gap-2 mt-4">
                      <div className="h-6 w-6 rounded-full bg-gray-600 overflow-hidden">
                        <img src={avatarUrl} alt={name || "Unknown"} />
                      </div>
                      <p className="text-sm text-start text-white">{name}</p>
                    </div>
                  )
                }}
              />
            )}

            {!isEmpty(ticketAddOns) && (
              <Controller
                name={`tickets.${index}.isExtendAddOns`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div className="border-t-[0.1px] border-b-[0.1px] border-white/10 py-4 mt-4">
                    <div
                      // className={` ${!isSingleTicket && "border-t-[0.1px] border-b-[0.1px] mt-4"} flex flex-row items-center border-white/10 py-4 cursor-pointer`}
                      className={`flex flex-row items-center border-white/10 cursor-pointer`}
                      onClick={() => onChange(!value)}
                    >
                      <p className="text-white flex flex-1">Choose an add-on</p>

                      {value ? (
                        <FaSquareMinus className="text-white text-xl" />
                      ) : (
                        <FaSquarePlus className="text-white text-xl" />
                      )}
                    </div>

                    {value && (
                      <Controller
                        name={`tickets.${index}.ticketAddOns`}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="flex flex-col gap-2 mt-4">
                            {value.map((addOns, index) => {
                              const isSelected = get(
                                addOns,
                                "isSelected",
                                false,
                              )

                              const onSelectAddOns = () => {
                                const updateTicketAddOns = map(
                                  value,
                                  function (obj, i) {
                                    return {
                                      ...obj,
                                      isSelected:
                                        i === index
                                          ? !get(obj, "isSelected")
                                          : get(obj, "isSelected"),
                                    }
                                  },
                                )

                                onChange(updateTicketAddOns)
                              }

                              return (
                                <div
                                  key={`addOns-${index}`}
                                  className="flex flex-row pl-4 gap-2 cursor-pointer"
                                  onClick={() => onSelectAddOns()}
                                >
                                  {isSelected ? (
                                    <FaSquareCheck className="text-white text-xl mt-0.5" />
                                  ) : (
                                    <FaRegSquare className="text-white text-xl mt-0.5" />
                                  )}

                                  <div className="flex flex-1 flex-col gap-0.5">
                                    <p className="text-start text-sm text-white">
                                      {get(addOns, "ticketName", "")}
                                    </p>
                                    <div className="flex flex-row items-center">
                                      <p
                                        className="text-sm text-gray-400 cursor-pointer"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setAddOnsDetails(addOns)
                                          modalRef.current?.openModal()
                                        }}
                                      >
                                        More info
                                      </p>
                                      <LuChevronDown
                                        className="text-gray-400 text-xl cursor-pointer"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setAddOnsDetails(addOns)
                                          modalRef.current?.openModal()
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <p className="text-white text-sm">
                                    ${get(addOns, "ticketPrice", 0)}
                                  </p>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      />
                    )}
                  </div>
                )}
              />
            )}

            {/* {!isSingleTicket && (
              <Controller
                name={`tickets.${index}.isManual`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div
                    className="mt-4 border-t-[0.1px] border-t-white/10 pt-4 cursor-pointer"
                    onClick={() => onChange(!value)}
                  >
                    <p className="text-white">Add info manually</p>
                  </div>
                )}
              />
            )} */}

            {isQuestionnairesNeeded && (
              <Controller
                name={`tickets.${index}.attendeeQuestionersAnswer`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <button
                    className="mt-4 flex w-full flex-row items-center justify-center gap-4 bg-white/10"
                    onClick={() => {
                      onFillQuestioners(index)
                    }}
                  >
                    <p className="text-white">Fill out questionnaire</p>
                    {!isEmpty(value) && (
                      <LuCircleCheck className="text-white35 text-md md:text-2xl" />
                    )}
                  </button>
                )}
              />
            )}
          </>
        )}
      </div>
    )
  }

  const additionalDetailsPreview = (index) => {
    const ticketAddOns = filter(
      get(form, `tickets.${index}.ticketAddOns`, []),
      ["isSelected", true],
    )
    return (
      <>
        {!isEmpty(ticketAddOns) && (
          <Controller
            name={`tickets.${index}.ticketAddOns`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <div className="flex flex-col gap-3 mt-4">
                {value.map((addOns, index) => {
                  const isSelected = get(addOns, "isSelected", false)

                  const onSelectAddOns = () => {
                    const updateTicketAddOns = map(value, function (obj, i) {
                      return {
                        ...obj,
                        isSelected:
                          i === index
                            ? !get(obj, "isSelected")
                            : get(obj, "isSelected"),
                      }
                    })

                    onChange(updateTicketAddOns)
                  }

                  if (isSelected) {
                    return (
                      <div
                        key={`addOns-${index}`}
                        className="flex flex-row gap-2 cursor-pointer items-center"
                        onClick={() => onSelectAddOns()}
                      >
                        {isSelected ? (
                          <FaSquareCheck className="text-white text-xl" />
                        ) : (
                          <FaRegSquare className="text-white text-xl" />
                        )}

                        <div className="flex flex-1 flex-col">
                          <p className="text-start text-sm text-white">
                            {get(addOns, "ticketName", "")}
                          </p>
                        </div>

                        <p className="text-white text-sm">
                          ${get(addOns, "ticketPrice", 0)}
                        </p>
                      </div>
                    )
                  } else {
                    return null
                  }
                })}
              </div>
            )}
          />
        )}

        {isQuestionnairesNeeded && (
          <>
            <div className="h-[0.1px] bg-white/10 my-4"></div>
            <Controller
              name={`tickets.${index}.attendeeQuestionersAnswer`}
              control={control}
              render={({ field: { value, onChange } }) => {
                const isQuestionnairesAnswered = isEmpty(value)

                if (isQuestionnairesAnswered) {
                  return (
                    <button
                      className="mt-4 flex w-full flex-row items-center justify-center gap-4 bg-white/10"
                      onClick={() => {
                        onFillQuestioners(index)
                      }}
                    >
                      <p className="text-white">Fill out questionnaire</p>
                    </button>
                  )
                } else {
                  return (
                    <div
                      className="flex flex-row items-center cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation()
                        onFillQuestioners(index)
                      }}
                    >
                      <div className="flex flex-1 items-center gap-2">
                        <FaSquareCheck className="text-white text-xl" />
                        <p className="text-white">Questionnaires</p>
                      </div>

                      <FiEdit className="text-white35 text-md md:text-lg" />
                    </div>
                  )
                }
              }}
            />
          </>
        )}
      </>
    )
  }

  const ContentComponent = () => (
    <div className="mb-32">
      <div className="flex flex-col items-center justify-center md:justify-start px-4">
        {/* <div className="flex flex-col items-center justify-center md:justify-start min-h-screen px-4 md:mt-36"> */}
        <div className="mb-8 text-start w-full max-w-sm">
          <p className="text-white/30 text-left text-sm mt-10 md:mt-0 lg:mt-0 font-medium">
            STEP 2
          </p>
          <FancyText className="text-2.5xl mt-[10px] text-white font-semibold">
            {isSingleTicket
              ? "Complete your questionnaire"
              : "Complete each questionnaire"}
          </FancyText>
        </div>

        <div className="space-y-4 w-full max-w-sm">
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* <div className="h-full max-h-[65vh] md:max-h-[60vh] overflow-auto"> */}
            <div className="h-full">
              {fields.map((ticket, index) => (
                <Controller
                  key={`tickets.${index}`}
                  name={`tickets.${index}.isExpanded`}
                  control={control}
                  render={({ field: { value, onChange } }) => {
                    const isManual = get(
                      form,
                      `tickets.${index}.isManual`,
                      false,
                    )
                    const isDetailsAdded = get(
                      form,
                      `tickets.${index}.isDetailsAdded`,
                      false,
                    )
                    const hasError = !isEmpty(get(errors, `tickets.${index}`))

                    return (
                      <div
                        key={index}
                        className={`bg-white/20 rounded-lg shadow-md mb-4 ${hasError && "border border-red-500"} `}
                      >
                        <div
                          className={`flex flex-row p-4 cursor-pointer items-center`}
                          onClick={() => {
                            if (isManual && value && !isDetailsAdded) {
                              onAddManualDetails(index)
                            } else {
                              onToggleItem(index)
                            }
                          }}
                        >
                          <p className="flex flex-1 text-start text-white text-lg font-semibold">
                            {get(ticket, "label", "")}
                          </p>

                          {/* {isManual && value && !isDetailsAdded ? (
                              <LuCircleCheck className="text-white35 text-md md:text-2xl" />
                            ) : ( */}
                          <>
                            {isDetailsAdded ? (
                              <FiEdit className="text-white35 text-md md:text-lg" />
                            ) : (
                              <>
                                {value ? (
                                  <LuChevronUp className="text-white35 text-md md:text-2xl" />
                                ) : (
                                  <LuChevronDown className="text-white35 text-md md:text-2xl" />
                                )}
                              </>
                            )}
                          </>
                          {/* )} */}
                        </div>

                        <Controller
                          name={`tickets.${index}.isDetailsAdded`}
                          control={control}
                          render={({
                            field: { value: isDetailsAdded, onChange },
                          }) => {
                            const avatarUrl = get(
                              form,
                              `tickets.${index}.avatarUrl`,
                              "",
                            )
                            const name = get(form, `tickets.${index}.name`, "")
                            const displayedPhoneNumber = get(
                              form,
                              `tickets.${index}.displayedPhoneNumber`,
                              "",
                            )
                            const countryPhoneCode = get(
                              form,
                              `tickets.${index}.countryPhoneCode`,
                              "",
                            )

                            if (isDetailsAdded) {
                              if (!isManual) {
                                return (
                                  <div className="px-4 pb-4">
                                    <div className="h-[0.1px] bg-white/10 -mt-2"></div>
                                    <div className="flex flex-row gap-2 mt-4">
                                      <div className="h-6 w-6 rounded-full bg-gray-600 overflow-hidden">
                                        <img
                                          src={avatarUrl}
                                          alt={name || "Unknown"}
                                        />
                                      </div>
                                      <p className="text-sm text-start text-white">
                                        {name}
                                      </p>
                                    </div>
                                    {additionalDetailsPreview(index)}
                                  </div>
                                )
                              } else {
                                return (
                                  <div className="px-4 pb-4">
                                    <div className="h-[0.1px] bg-white/10 -mt-2"></div>
                                    <div className="flex flex-col gap-3 mt-4">
                                      <p className="text-sm text-start text-white/80">
                                        {name}
                                      </p>
                                      <p className="text-sm text-start text-white/80">
                                        {countryPhoneCode +
                                          " " +
                                          displayedPhoneNumber}
                                      </p>
                                    </div>
                                    {additionalDetailsPreview(index)}
                                  </div>
                                )
                              }
                            } else {
                              return (
                                <>
                                  {value ? (
                                    renderFriendsInfoFormItem(ticket, index)
                                  ) : (
                                    <div className="px-4 pb-4 -mt-4">
                                      {searchNumberView(index)}
                                      {additionalDetailsPreview(index)}
                                    </div>
                                  )}
                                </>
                              )
                            }
                          }}
                        />
                      </div>
                    )
                  }}
                />
              ))}
            </div>
            {errors &&
              errors?.tickets &&
              errors?.tickets[0] &&
              errors?.tickets[0]?.attendeeQuestionersAnswer && (
                <div className="text-red-500 text-start text-sm mb-2">
                  Questionnaire must be filled out completely
                </div>
              )}
            {/* <div className="absolute bottom-0 left-0 right-0 bg-white/5">
            <div className="flex items-center justify-center my-8 self-center">
              <button
                className="px-6 lg:px-8 min-w-80 bg-white/10 rounded-full border text-white"
                type="submit"
              >
                Continue
              </button>
            </div>
          </div> */}
          </form>
          <InfoModal ref={modalRef}>
            <div className="text-center">
              <h2 className="text-white text-2xl font-medium">
                {get(addOnsDetails, "ticketName", "")}
              </h2>

              <div className="h-[0.1px] bg-white/10 my-4"></div>
              <p className="text-white text-justify">
                {get(addOnsDetails, "ticketDescriptions", "")}
              </p>
            </div>
          </InfoModal>
        </div>
      </div>
      <div className="mt-4 mb-2">
        <GenericFeedback
          fromScreen="Choose Ticket"
          userId={userId}
          showOnDesktop={true}
        />
        <GenericFeedback fromScreen="Choose Ticket" userId={userId} />
      </div>
    </div>
  )

  const FooterComponent = () => (
    <div className="w-full py-4">
      <div className="flex items-center justify-center self-center">
        <button
          className="px-6 lg:px-8 min-w-80 w-full max-w-sm mx-4 bg-white/10 rounded-full border text-white"
          onClick={handleSubmit(onSubmit)}
        >
          {ticketsWithTotalPrice > 0
            ? `Continue - $${ticketsWithTotalPrice}`
            : "Continue"}
        </button>
      </div>
    </div>
  )

  return (
    <>
      {eventId && isLoading && <BlurredLoadingSpinner />}
      <BuyTicketsLayout
        header={HeaderComponent()}
        content={ContentComponent()}
        footer={FooterComponent()}
        bgImage={flyerImage}
        overlayOpacity="75"
        overlayColor="dark"
      />
    </>
  )
}

export default FillFriendsTicketInfo
